export const SHOW = 'ccs/message/SHOW';
export const CLEAR = 'ccs/message/CLEAR';

const initialState = {
  show: false,
  data: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW:
      return {
        show: true,
        data: action.data,
      };
    case CLEAR:
      return initialState;

    default:
      return state;
  }
}

export const showMessage = (data) => ({
  type: SHOW,
  data,
});

export const clearMessages = () => ({
  type: CLEAR,
});

export function showAndHide(data, ms = 5000) {
  return function (dispatch) {
    dispatch(showMessage(data));
    setTimeout(() => {
      dispatch(clearMessages());
    }, ms);
  };
}
